import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loading: false,
  workOrders: [],
  totalWorkOrders: 0,
  error: null
};

const route = "modules/workOrders/views/main/components/workOrderTab/redux/slice.";

const workOrdersSearchWorkOrders = createAsyncThunk(
  "workOrders/workOrderTab/workOrdersSearchWorkOrders",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        workOrdersSearchWorkOrders.query,
        {
          conditions,
          sort,
          limit: limit || 10,
          offset: offset > -1 ? offset : 0,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchCustomerLocations");
      return rejectWithValue(exc);
    }
  }
);

workOrdersSearchWorkOrders.query = `
    query ($conditions: [WorkOrderSearchInput], $sort: [WorkOrderSortInput], $limit: Int, $offset: Int) {
        data: searchWorkOrders(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                customerId
                customer {
                  id
                  name
                }
                customerLocationId
                customerLocation {
                  id
                  name
                  address
                  latitude
                  longitude
                }
                workOrderTypeId
                workOrderType {
                  id
                  name
                }
                workOrderNumber
                description
                driverId
                driver {
                  id
                  title
                  avatarFile {
                    id
                    repositoryId
                    repositoryType
                    repositoryCode
                    repositoryPath
                    fileKey
                    originalName
                  }
                }
                scheduledDate
                closedDate
                estimatedDurationMins
                severity
                statusId
                status {
                  id
                  name
                  color
                }
                statusUpdatedOn
                dynamicFormAnswerId
            }
        }
    }
`;

export { workOrdersSearchWorkOrders };

export const updateWorkOrderTabItem = createAsyncThunk("workOrders/workOrderTab/updateWorkOrderMainItem", async (payload, { rejectWithValue, dispatch, getState }) => {
  const { id, key, items = [], total = 0 } = payload;
  if (key === "UPDATE") {
    const response = await clientQuery(
      `
        query ($id: Int!) {
            data: getWorkOrder(
                id: $id
            ) {
                id
                customerId
                customer {
                  id
                  name
                }
                customerLocationId
                customerLocation {
                  id
                  name
                  address
                  latitude
                  longitude
                }
                workOrderTypeId
                workOrderType {
                  id
                  name
                }
                workOrderNumber
                description
                driverId
                driver {
                  id
                  title
                  avatarFile {
                    id
                    repositoryId
                    repositoryType
                    repositoryCode
                    repositoryPath
                    fileKey
                    originalName
                  }
                }
                scheduledDate
                closedDate
                estimatedDurationMins
                severity
                statusId
                status {
                  id
                  name
                  color
                }
                statusUpdatedOn
            }
        }
      `,
      {
        id: id
      },
      endpoints.GRAPHQL_GENERAL_V2
    );
    if (response?.data) {
      const updatedWorkOrders = items.map((item) =>
        item.id === response?.data.id ? { ...item, ...response?.data } : item
      );
      return { items: updatedWorkOrders, total: total };
    }
  } else if (key === "DELETE") {
    const exists = items.some(item => item.id === id);
    if (exists) {
      const updatedWorkOrders = items.filter((item) => item?.id !== id);
      return { items: updatedWorkOrders, total: total > 0 ? total - 1 : 0 };
    }
  }
  return { items, total };
})

//Slice
const workOrdersWorkOrderTabRedux = createSlice({
  name: "workOrders/workOrderTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //workOrdersSearchWorkOrders
    builder.addCase(workOrdersSearchWorkOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrdersSearchWorkOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.workOrders = action.payload.items;
      state.totalWorkOrders = action.payload.total;
    });
    builder.addCase(workOrdersSearchWorkOrders.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //updateWorkOrderTabItem
    builder.addCase(updateWorkOrderTabItem.pending, (state) => { });
    builder.addCase(updateWorkOrderTabItem.fulfilled, (state, action) => {
      state.workOrders = action.payload.items;
      state.totalWorkOrders = action.payload.total;
    });
    builder.addCase(updateWorkOrderTabItem.rejected, (state, action) => { });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersWorkOrderTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
